const api = "https://protonmail-clone.onrender.com/api"

export default api
